import {
  faPencilAlt,
  faRotateRight,
  faTrashAlt,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useQuery } from "@tanstack/react-query";
import { createRef, useCallback, useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { B2Button } from "@hdb/biome-2";
import { w3cwebsocket as W3CWebSocket } from "websocket";
import * as yup from "yup";
import resetBtn from "../../../../../../assets/images/arrow-repeat.png";
import circleCheck from "../../../../../../assets/images/circle-check.png";
import circleCross from "../../../../../../assets/images/circle-cross.png";
import { getGatewayGroup } from "../../../../../../core/api/services/asset/gateway-group.service";
import { getLuminanceProfile } from "../../../../../../core/api/services/asset/light-profile/luminance-profile.service";
/* import {
  getToken,
  getUserInfo,
} from "../../../../../../core/auth/auth.service"; */
import MfaComponent from "../../../../../../core/components/mfa/mfa.component";
import ModalComponent from "../../../../../../core/components/modal/modal.component";
import TableComponent from "../../../../../../core/components/table/table.component";
import { AssetCommandEnums } from "../../../../../../core/enums/assetCommands-enums";
import { WEBSOCKET_MAX_RETRY_COUNT } from "../../../../../../core/enums/notification-type-enums";
import HasPermission from "../../../../../../core/guards/has-permission";
import FormBuilderComponent, {
  FormConfig,
} from "../../../../../../shared/form-builder/form-builder.component";
import { safeAtob } from "../../../../../../shared/helpers/enode-decode-string";
import TableSort from "../../../../../../shared/helpers/table-sort";
import capitalizeFirst from "../../../../../../shared/helpers/upper-case";
import {
  deleteLuminanceProfile,
  enableOrDisableLuminanceProfile,
  getDaysOfWeek,
  getLuminanceProfileByCode,
  postLuminanceProfile,
  resetLuminanceProfile,
  sendGetCommandToDms,
  updateLuminanceProfile,
} from "../../../../../../store/slices/asset.slice";
import { setOtpIsValidation } from "../../../../../../store/slices/mfa-otp.slice";
import * as _ from "lodash";
import { Helmet } from "react-helmet-async";
import { getUserInfo } from "src/core/auth/auth.service";
import { displayToast } from "src/shared/helpers/toaster.helper";

const LuminanceProfileComponent = () => {
  const user = getUserInfo();
  const dispatch = useDispatch();
  const params: any = useParams();
  const id = params.id ? safeAtob(params.id) : null;
  const formRef = createRef();
  const repeatActionFormRef = createRef();
  const [PageNumber, setPageNum] = useState<number>(1);
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [groupOptions, setGroupOptions] = useState<any>([]);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [isDetails, setIsDetails] = useState<boolean>(false);
  const [isDelete, setIsDelete] = useState<boolean>(false);
  const [isEnable, setIsEnable] = useState<boolean>(false);
  const [currentFeature, setCurrentFeature] = useState("" as any);
  const [isOTPModalOpen, setIsOtpModalOpen] = useState<boolean>(false);
  const [isRefreshing, setIsRefreshing] = useState<boolean>(false);

  const [SortBy, setSortBy] = useState<any>(capitalizeFirst("profileName"));
  const [SortDirection, setSortDirection] = useState<any>("desc");
  const [selectedIdToDeleteOrEdit, setSelectedIdToDeleteOrEdit] =
    useState<number>(0);
  const [onRefetchEnabled, setOnRefetchEnabled] = useState<boolean>(false);

  const [initialValues, setInitialValues] = useState<any>({
    profileName: "",
    startDate: "",
    endDate: "",
    repeatAction: 30,
    zoneID: "",
    luminanaceLevel: "",
  });

  const [repeatActionInitialValues, setRepeatActionInitialValues] =
    useState<any>({
      repeatAction: 30,
    });

  const [isRepeatActionModalOpen, setIsRepeatActionModalOpen] =
    useState<boolean>(false);

  const mfaInfo = useSelector((state: any) => {
    return state.user.mfaInfo;
  });

  const socketData = useSelector((state: any) => {
    return state.asset.socketData;
  });

  // const [isCallRetry, setIsCallRetry] = useState(false);
  // const [retryCount, setRetryCount] = useState<number>(0);
  // const [socketStatus, setSocketStatus] = useState("initial");
  // const [socket, setSocket] = useState<any>(null);
  // const token = getToken();

  // const connectSocket = () => {
  //   const luminanceProfileClient = new W3CWebSocket(
  //     `${process.env.REACT_APP_WS_BASE_URL}/slpapp/push?name=asset-luminanceprofile`
  //   );

  //   luminanceProfileClient.onopen = () => {
  //     console.log("WebSocket Luminance Profile Client Connected");

  //     setSocketStatus("open");
  //     luminanceProfileClient.send(
  //       JSON.stringify({ token: new Date().getUTCMilliseconds() })
  //     );
  //     setRetryCount(0);
  //   };

  //   luminanceProfileClient.onmessage = (message) => {
  //     const data = JSON.parse(`${message.data}`);
  //     const user = getUserInfo();
  //     if (
  //       user.email.toLowerCase() === data.NotificationIdentifier.toLowerCase()
  //     ) {
  //       toast.success("Acknowledgement Received", {
  //         position: "top-right",
  //         autoClose: 3000,
  //         hideProgressBar: false,
  //         closeOnClick: false,
  //         pauseOnFocusLoss: true,
  //         draggable: true,
  //         pauseOnHover: true,
  //       });
  //     }

  //     refetchLuminanceProfile();
  //   };

  //   luminanceProfileClient.onclose = (event) => {
  //     console.log("WebSocket slpclientlp Closed", event);

  //     setSocketStatus("closed");
  //     setIsCallRetry((prev: boolean) => !prev);
  //   };

  //   setSocket(luminanceProfileClient);
  // };

  // useEffect(() => {
  //   setRetryCount((current: number) => current + 1);

  //   if (socketStatus == "initial") {
  //     connectSocket();
  //   } else if (socketStatus == "closed") {
  //     if (retryCount < WEBSOCKET_MAX_RETRY_COUNT) {
  //       setTimeout(() => {
  //         console.log(
  //           `Luminance Profile Retry Attempts ${retryCount}/${WEBSOCKET_MAX_RETRY_COUNT}}`
  //         );

  //         connectSocket();
  //       }, 5000);
  //     } else {
  //       console.log(
  //         `Maximum retry attempts reached for luminance Profile WebSocket`
  //       );
  //     }
  //   }

  //   return () => {
  //     if (socket && socket.readyState === socket.OPEN) {
  //       socket.close();
  //       console.log("Luminance Profile Client socket closed");
  //     }
  //   };
  // }, [socketStatus, isCallRetry]);

  const socketRealTimeUpdate = useSelector((state: any) => {
    return state.asset.socketRealTimeUpdate;
  });

  const socketRealTimeUpdateData = useSelector((state: any) => {
    return state.asset.socketRealTimeUpdateData;
  });

  useEffect(() => {
    dispatch({
      type: "table/toggleSelectAll",
      payload: [],
    });

    dispatch(getDaysOfWeek());
  }, [dispatch]);

  const daysOfWeek = useSelector((state: any) => {
    return state.asset.daysOfWeek;
  });

  const luminanaceProfile = useSelector((state: any) => {
    return state.asset.luminanceProfileDetails;
  });

  const [daysOfWeekOptions, setDaysOfWeekOptions] = useState<any>([]);

  useEffect(() => {
    if (luminanaceProfile && Object.keys(luminanaceProfile).length > 0) {
      const data = {
        profileName: luminanaceProfile?.profileName || null,
        startDate: luminanaceProfile?.startDate || null,
        endDate: luminanaceProfile?.endDate || null,
        repeatAction: luminanaceProfile?.repeatAction || 0,
        zoneID: luminanaceProfile?.zoneId || 0,
        luminanaceLevel: luminanaceProfile?.luminanceLevel || null,
      };

      setInitialValues(data);
    }
  }, [luminanaceProfile]);

  useEffect(() => {
    const days = daysOfWeek?.map((day: any) => ({
      value: day?.id,
      label: day?.name,
    }));

    setDaysOfWeekOptions(days);
  }, [daysOfWeek]);

  const pageSize = 10;

  const {
    data: luminanceProfiles,
    isLoading: isLoadingLuminanceProfiles,
    refetch: refetchLuminanceProfile,
  } = useQuery({
    queryKey: [
      "getLuminanceProfile",
      pageSize,
      PageNumber,
      SortBy,
      SortDirection,
      id,
    ],
    queryFn: () =>
      getLuminanceProfile(pageSize, PageNumber, SortBy, SortDirection, id),
    // enabled: onRefetchEnabled
  });

  const showToaster = (socketRealTimeUpdateData: any) => {
    if (
      user[
      "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier"
      ] === socketData?.NotificationIdentifier
    ) {
      displayToast(
        socketRealTimeUpdateData?.PushMessage || "Acknowledgement Received",
        socketRealTimeUpdateData?.ToasterColor
      );
    }
  };

  useEffect(() => {
    const copiedSocketRealTimeUpdate = _.cloneDeep(socketRealTimeUpdate);

    if (copiedSocketRealTimeUpdate.LuminanceProfile) {
      showToaster(socketRealTimeUpdateData);
      refetchLuminanceProfile();
      setOnRefetchEnabled(true);
    }
  }, [socketRealTimeUpdate]); // socketRealTimeUpdateData

  const { data: gatewayGroups } = useQuery({
    queryKey: ["getGatewayGroup", id],
    queryFn: () => getGatewayGroup(id!),
    enabled: isModalOpen,
  });

  useEffect(() => {
    const groups = gatewayGroups?.data?.map((group: any) => ({
      value: group?.zoneId,
      label: group?.groupName + ` (Zone - ${group?.zoneId})`,
    }));

    setGroupOptions(groups);
  }, [gatewayGroups]);

  const formConfig: FormConfig = {
    controls: [
      {
        name: "profileName",
        label: "Profile Name",
        placeholder: "Profile Name",
        type: "text",
        required: true,
        readOnly: isDetails,
        disabled: isDetails,
      },
      {
        name: "startDate",
        label: "Start Date",
        placeholder: "Start Date",
        type: "date",
        required: true,
        readOnly: isDetails,
        disabled: isDetails,
      },
      {
        name: "endDate",
        label: "End Date",
        placeholder: "End Date",
        type: "date",
        required: true,
        readOnly: isDetails,
        disabled: isDetails,
      },
      {
        name: "zoneID",
        label: "Group",
        placeholder: "Select Group",
        type: "select",
        options: groupOptions,
        required: true,
        readOnly: isDetails,
        disabled: isDetails,
      },
      {
        name: "luminanaceLevel",
        label: "Luminance Level (%)",
        placeholder: "e.g: 80",
        type: "number",
        required: true,
        readOnly: isDetails,
        disabled: isDetails,
      },
    ],
  };

  const repeatActionFormConfig: FormConfig = {
    controls: [
      {
        name: "repeatAction",
        label: "Repeat Action",
        placeholder: "Repeat Action",
        type: "number",
        required: true,
        readOnly: isDetails,
        disabled: isDetails,
      },
    ],
  };

  const selectedItems = useSelector((state: any) => state.table.selectedItems);

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setIsEdit(false);
    setIsDetails(false);
    setIsDelete(false);
    setIsOtpModalOpen(false);
  };

  const deleteAction = (luminanceProfileId: any) => {
    // console.log("luminanceProfileId", luminanceProfileId);

    setIsDetails(false);
    setIsModalOpen(true);
    setIsEdit(false);
    setIsDelete(true);

    // console.log("isDelete", isDelete);

    setSelectedIdToDeleteOrEdit(luminanceProfileId);
  };

  const handleChangePage = useCallback((page: number): void => {
    setPageNum(page);
  }, []);

  const onSubmit = () => {
    const form: any = formRef.current;

    if (form) {
      form.handleSubmit();

      const { profileName, startDate, endDate, zoneID, luminanaceLevel } =
        form.values;

      const trimmedProfileName = profileName.trim();

      if (
        !trimmedProfileName ||
        !startDate ||
        !endDate ||
        !zoneID ||
        !luminanaceLevel
      ) {
        return;
      }

      const data = {
        ...form.values,
        assetCode: id,
        id: selectedIdToDeleteOrEdit,
      };

      if (isEdit) {
        dispatch(updateLuminanceProfile({ body: data })).then(() => {
          refetchLuminanceProfile();
        });
      } else {
        dispatch(postLuminanceProfile({ body: data })).then(() => {
          refetchLuminanceProfile();
        });
      }
    }

    handleCloseModal();
  };

  //
  const editAction = (id: number) => {
    setIsEdit(true);
    setIsModalOpen(true);
    setIsDetails(false);
    setIsDelete(false);

    dispatch(getLuminanceProfileByCode({ luminanceProfileId: id }));

    setSelectedIdToDeleteOrEdit(id);
  };
  const handleAdd = () => {
    setInitialValues({
      profileName: "",
      startDate: "",
      endDate: "",
      repeatAction: 30,
      zoneID: "",
      luminanaceLevel: "",
    });

    setIsDetails(false);
    setIsModalOpen(true);
    setIsEdit(false);
    setIsDelete(false);
  };

  const validationSchema = yup.object().shape({
    profileName: yup.string().trim().required("Profile Name is required"),
    startDate: yup.string().required("Start Date is required"),
    endDate: yup.string().required("End Date is required"),
    zoneID: yup.string().required("Zone is required"),
    luminanaceLevel: yup.string().required("Luminance Level is required"),
  });

  const repeatActionValidation = yup.object().shape({});

  const handleReset = () => {
    setCurrentFeature("reset");

    if (mfaInfo?.isDMSMfaEnabled) {
      setIsOtpModalOpen(true);
    } else {
      onSubmitMfaOtp();
    }
  };

  const handleProfileEnableDisable = (enable: boolean) => {
    setCurrentFeature("enableOrDisable");

    const ids = selectedItems?.map((item: any) => item?.value);

    if (ids?.length <= 0) {
      return;
    }

    if (mfaInfo?.isDMSMfaEnabled) {
      setIsOtpModalOpen(true);
    } else {
      onSubmitMfaOtp();
    }

    setIsEnable(enable);
  };

  const onSubmitMfaOtp = () => {
    switch (currentFeature) {
      case "reset":
        dispatch(resetLuminanceProfile({ assetCode: id }));
        break;
      case "enableOrDisable":
        if (!isEnable) {
          const ids = selectedItems?.map((item: any) => item?.value);
          dispatch(
            enableOrDisableLuminanceProfile({ body: ids, isEnable: isEnable })
          );
        } else {
          setIsRepeatActionModalOpen(true);
        }
        break;
      default:
        break;
    }

    dispatch(setOtpIsValidation(false));
    handleCloseModal();
  };

  const handleRefresh = () => {
    setIsRefreshing(true);
    dispatch(
      sendGetCommandToDms({
        assetCode: id,
        module: Number(AssetCommandEnums.LuminanceProfile),
      })
    )
      .then(() => {
        refetchLuminanceProfile()
          .then(() => {
            setIsRefreshing(false);
          })
          .catch(() => {
            setIsRefreshing(false);
          });
      })
      .catch(() => {
        setIsRefreshing(false);
      });
  };

  const [columns, setColumns] = useState([
    {
      title: "Profile Name",
      label: "profileName",
      isSorted: true,
      // width: "8rem"
    },
    {
      title: "Start Date",
      label: "startDate",
      // width: "10rem"
    },
    {
      title: "Group",
      label: "group",
    },
    {
      title: "Luminance Level (%)",
      label: "luminanceLevel",
      // width: "13rem"
    },
    {
      title: "Status",
      label: "status",
    },
  ]);

  const handleChangeSort = useCallback(
    async (sortBy: string, sortDirection: any) => {
      if (!sortBy || !sortDirection) return;
      setSortBy(sortBy);
      setSortDirection(sortDirection);

      const copyColumns: any = await TableSort(columns, sortBy);
      setColumns(copyColumns);
    },
    []
  );

  const isOtpVerified = useSelector((state: any) => {
    return state.otp.isOtpVerified;
  });

  const onSubmitRepeatAction = () => {
    const form: any = repeatActionFormRef.current;

    if (form) {
      form.handleSubmit();

      setRepeatActionInitialValues({
        repeatAction: form.values.repeatAction,
      });

      const ids = selectedItems?.map((item: any) => item?.value);

      dispatch(
        enableOrDisableLuminanceProfile({
          body: ids,
          isEnable: isEnable,
          repeatAction: form.values.repeatAction,
        })
      );
      setIsRepeatActionModalOpen(false);
    }
  };

  const handleCloseOtpModal = () => {
    setIsOtpModalOpen(false);
  };

  const handleCloseRepeatActionModal = () => {
    setIsRepeatActionModalOpen(false);
  };

  const handleDelete = () => {
    dispatch(
      deleteLuminanceProfile({ luminanceProfileId: selectedIdToDeleteOrEdit })
    ).then(() => {
      refetchLuminanceProfile();
      handleCloseModal();
    });
  };

  function isDisplayButton(data: any, label: any): boolean {
    if (data?.isBaseProfile) {
      return false;
    }
    return true;
  }

  const modalActionConfig = isDetails
    ? []
    : isDelete
      ? [
        {
          label: "Yes",
          event: handleDelete,
          variant: "primary",
        },
      ]
      : [
        {
          label: "Save",
          event: onSubmit,
          variant: "primary",
        },
      ];

  const mfaActionConfig: any = [
    {
      label: "Save",
      event: onSubmitMfaOtp,
      variant: "primary",
      disabled: !isOtpVerified,
    },
  ];

  const RepeatActionConfig: any = [
    {
      label: "Save",
      event: onSubmitRepeatAction,
      variant: "primary",
    },
  ];

  const actionConfig: any = [
    {
      label: "Edit",
      actionProperty: "id",
      event: editAction,
      variant: "secondary",
      className: "mx-2 my-1",
      moduleName: "Luminance Profile",
      actionName: "Edit-Luminance Profile",
      icon: faPencilAlt,
    },
    {
      label: "Delete",
      actionProperty: "id",
      event: deleteAction,
      isDisplay: isDisplayButton,
      variant: "danger",
      className: "mx-2 my-1",
      moduleName: "Luminance Profile",
      actionName: "Delete-Luminance Profile",
      icon: faTrashAlt,
    },
  ];

  return (
    <>
      <Helmet>
        <title>Luminance Profile | Asset</title>
      </Helmet>
      <div>
        <div className="bg-card table-generic-action">
          <div className="d-flex justify-content-end">
            <HasPermission
              moduleName="Luminance Profile"
              actionName="Add-Luminance Profile"
              isRoute={false}
            >
              <div>
                <B2Button
                  className=""
                  variant="default"
                  onClick={handleRefresh}
                >
                  <FontAwesomeIcon icon={faRotateRight} className="fs-7 me-2" />
                  Refresh
                </B2Button>
                {/*                 <B2Button className="" variant="default" onClick={handleReset}>
                  <img
                    src={resetBtn}
                    alt="reset"
                    height={"20px"}
                    className="me-2"
                  />
                  Reset
                </B2Button> */}

                <B2Button variant="primary" onClick={handleAdd}>
                  Add Luminance Profile
                </B2Button>
              </div>
            </HasPermission>
          </div>

          <div className="my-3">
            <TableComponent
              tableHeaders={columns}
              data={luminanceProfiles?.data}
              totalNumberOfRecords={luminanceProfiles?.numberOfRecords}
              pageSize={pageSize}
              current={PageNumber}
              onChangePage={handleChangePage}
              onChangeSort={handleChangeSort}
              enableSelection={true}
              isLoadingData={isLoadingLuminanceProfiles || isRefreshing}
              actionConfig={actionConfig}
              count={5}
              wrapperHeight="350px"
              moduleName="Luminance Profile"
              actionName="Edit-Luminance Profile"
            />
          </div>

          <div className="my-3 d-flex justify-content-start align-items-center gap-3 table-generic-action ">
            <HasPermission
              moduleName="Luminance Profile"
              actionName="Enable-Luminance Profile"
              isRoute={false}
            >
              <B2Button
                className="d-flex justify-content-center align-items-center "
                variant="default"
                onClick={() => handleProfileEnableDisable(true)}
              >
                <img
                  src={circleCheck}
                  alt="enable"
                  height={"20px"}
                  className="me-2"
                />
                Enable Profile
              </B2Button>
            </HasPermission>

            <HasPermission
              moduleName="Luminance Profile"
              actionName="Disable-Luminance Profile"
              isRoute={false}
            >
              <B2Button
                className="d-flex justify-content-center align-items-center "
                variant="default"
                onClick={() => handleProfileEnableDisable(false)}
              >
                <img
                  src={circleCross}
                  alt="disable"
                  height={"20px"}
                  className="me-2"
                />
                Disable Profile
              </B2Button>
            </HasPermission>
          </div>
        </div>

        {/* modals */}

        {isModalOpen && (
          <ModalComponent
            showModal={isModalOpen}
            handleClose={handleCloseModal}
            headerTitle={
              isEdit
                ? "Edit Luminance Profile"
                : isDetails
                  ? "Luminance Profile Details"
                  : isDelete
                    ? "Delete Luminance Profile"
                    : "Add Luminance Profile"
            }
            actionConfig={modalActionConfig}
          >
            {isDelete ? (
              <h5 className="text-center">
                Are you sure to <b className="text-danger">Delete</b>?
              </h5>
            ) : (
              <FormBuilderComponent
                formRef={formRef}
                validation={validationSchema}
                initialValues={initialValues}
                formConfig={formConfig}
              />
            )}
          </ModalComponent>
        )}

        {isOTPModalOpen && (
          <ModalComponent
            showModal={isOTPModalOpen}
            handleClose={handleCloseOtpModal}
            actionConfig={mfaActionConfig}
            headerTitle={"Multi Factor Authentication"}
            isViewMode={false}
          >
            <MfaComponent />
          </ModalComponent>
        )}

        {isRepeatActionModalOpen && (
          <ModalComponent
            showModal={isRepeatActionModalOpen}
            handleClose={handleCloseRepeatActionModal}
            actionConfig={RepeatActionConfig}
            headerTitle={"Repeat Action"}
            isViewMode={false}
          >
            <FormBuilderComponent
              formRef={repeatActionFormRef}
              validation={repeatActionValidation}
              initialValues={repeatActionInitialValues}
              formConfig={repeatActionFormConfig}
            />
          </ModalComponent>
        )}
      </div>
    </>
  );
};

export default LuminanceProfileComponent;
